import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import 'yet-another-react-lightbox/styles.css';

interface Photo {
  src: string;
  year: number;
  month: number;
  day: number;
  label: string;
}

interface PhotoGalleryProps {
  photos: Photo[];
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ photos }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  if (photos.length === 0) {
    return (
      <div className="gallery-empty">
        <p>No photos yet</p>
      </div>
    );
  }

  const slides = photos.map(photo => ({ src: photo.src }));

  return (
    <div className="photo-gallery">
      <h4 className="gallery-title">Gallery</h4>
      <div className="gallery-grid">
        {photos.map((photo, index) => (
          <div
            key={photo.src}
            className="gallery-item"
            onClick={() => {
              setPhotoIndex(index);
              setLightboxOpen(true);
            }}
          >
            <img
              src={photo.src}
              alt={photo.label}
              loading="lazy"
              className="gallery-image"
            />
            <span className="gallery-date-tag">{photo.label}</span>
          </div>
        ))}
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={photoIndex}
        slides={slides}
        plugins={[Slideshow]}
        slideshow={{ autoplay: false, delay: 5000 }}
        on={{ view: ({ index }) => setPhotoIndex(index) }}
      />
    </div>
  );
};

export default PhotoGallery;
